module.exports = __webpack_public_path__ + "img/index-img-02.6e17b296.png";